import { ModalManager } from './manager';
import { Auth } from '../auth';
import { t } from '../i18n';

/**
 * Mock Telegram Login flow. Two-stage UX (header + spinner + success ✓) that
 * mirrors what the real Telegram Login Widget feels like, ported from the
 * legacy mockup. Will be replaced in B-006 by the real
 * `<script src="https://telegram.org/js/telegram-widget.js">` widget which
 * posts an `id` + `hash` we verify server-side using TELEGRAM_BOT_TOKEN.
 */

const TITLE_ID = 'telegram-mock-title';

export function openTelegramMock(opts: { redirectTo?: string } = {}): void {
  ModalManager.open({
    id: 'telegram-mock',
    panelClass: 'telegram-mock',
    labelledBy: TITLE_ID,
    render() {
      return `
<div class="telegram-mock__head">
  <span class="telegram-icon" aria-hidden="true">✈</span>
  <span id="${TITLE_ID}" class="telegram-mock__title">@roamzy_bot</span>
</div>
<div class="telegram-mock__body" data-stage="connecting">
  <div class="telegram-mock__spinner" aria-hidden="true"></div>
  <p class="telegram-mock__status">${t('auth.tgConnecting')}</p>
</div>
<p class="telegram-mock__footer">${t('auth.tgMockFooter')}</p>`;
    },
    onMount(panel) {
      const body = panel.querySelector<HTMLElement>('.telegram-mock__body');
      const status = panel.querySelector<HTMLElement>('.telegram-mock__status');
      if (!body || !status) return;

      const t1 = window.setTimeout(() => {
        body.dataset.stage = 'success';
        body.innerHTML = `<div class="telegram-mock__check" aria-hidden="true">✓</div><p class="telegram-mock__status">${t('auth.tgSignedIn')}</p>`;
      }, 1500);

      const t2 = window.setTimeout(() => {
        ModalManager.close('telegram-mock');
        void Auth.loginDev(`telegram-${Date.now()}`).then(() => {
          if (opts.redirectTo) {
            window.history.pushState({}, '', opts.redirectTo);
            window.dispatchEvent(new PopStateEvent('popstate'));
          }
        });
      }, 2200);

      return () => {
        window.clearTimeout(t1);
        window.clearTimeout(t2);
      };
    },
  });
}
